export default "__VITE_ASSET__03QOSuR9__"